import React from 'react';
import {EntityType} from '../../../constants/EntityTypes';
import formEntityIcon from '../../../images/formEntityIcon.png';
import menuEntityIcon from '../../../images/menuEntityIcon.png';
import procEntityIcon from '../../../images/procEntityIcon.png';
import repEntityIcon from '../../../images/repEntityIcon.png';
import wizEntityIcon from '../../../images/wizEntityIcon.png';

const EntityIcon: React.FC<{type: EntityType}> = ({type}) => {
    let img;
    let entityClass;

    switch (type) {
        case EntityType.FORM:
            img = formEntityIcon;
            entityClass = 'form-entity';
            break;
        case EntityType.DOCUMENT:
            img = menuEntityIcon;
            entityClass = 'menu-entity';
            break;
        case EntityType.PROCEDURE:
            img = procEntityIcon;
            entityClass = 'proc-entity';
            break;
        case EntityType.REPORT:
            img = repEntityIcon;
            entityClass = 'rep-entity';
            break;
        case EntityType.WIZARD:
            img = wizEntityIcon;
            entityClass = 'wiz-entity';
            break;
        default:
            img = procEntityIcon;
            entityClass = 'proc-entity';
            break;
    }

    return (
        <div className={`entity-icon ${entityClass}`}>
            <img src={img} alt="" />
        </div>
    );
};

export default EntityIcon;
